var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        { staticClass: "position-absolute license-warning" },
        [
          _c("div", { staticClass: "content" }, [
            _c("div", { staticClass: "left-box" }, [
              _c("div", { staticStyle: { "margin-left": "11px" } }, [
                _c(
                  "div",
                  {
                    staticClass: "font-24 font-weight",
                    staticStyle: { color: "#fa5151", "margin-top": "163px" },
                  },
                  [_vm._v("证照过期预警")]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "flex flex-col flex-center color-999 font-12 margin-top-5 margin-bottom-15",
                  },
                  [
                    _c("span", [_vm._v("数据更新于")]),
                    _c("span", [_vm._v(_vm._s(_vm.popupData.time))]),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "expire_box margin-bottom-30 flex flex-align-center pointer",
                    class: _vm.index === 1 ? "expire_bg" : "",
                    on: {
                      click: function ($event) {
                        return _vm.handleSelected(1)
                      },
                    },
                  },
                  [
                    _c("img", {
                      staticClass: "margin-x-10",
                      staticStyle: { width: "26px", height: "26px" },
                      attrs: {
                        src:
                          _vm.index === 1 ? _vm.expireActive : _vm.expireNormal,
                      },
                    }),
                    _c("div", { staticClass: "flex flex-col" }, [
                      _c(
                        "span",
                        {
                          staticClass: "font-light margin-bottom-5",
                          style:
                            _vm.index === 1 ? "color: #fa5151" : "color: #999",
                        },
                        [_vm._v("证照已过期")]
                      ),
                      _c(
                        "span",
                        { staticClass: "color-999 font-12 font-light" },
                        [_vm._v(_vm._s(_vm.detailData.expiredCount) + "人")]
                      ),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "soon_box flex flex-align-center pointer",
                    class: _vm.index === 2 ? "soon_bg" : "",
                    on: {
                      click: function ($event) {
                        return _vm.handleSelected(2)
                      },
                    },
                  },
                  [
                    _c("img", {
                      staticClass: "margin-x-10",
                      staticStyle: { width: "26px", height: "26px" },
                      attrs: {
                        src: _vm.index === 2 ? _vm.soonActive : _vm.soonNormal,
                      },
                    }),
                    _c("div", { staticClass: "flex flex-col" }, [
                      _c(
                        "span",
                        {
                          staticClass: "font-light margin-bottom-5",
                          style:
                            _vm.index === 2 ? "color: #ff8157" : "color: #666",
                        },
                        [_vm._v("证照即将过期")]
                      ),
                      _c(
                        "span",
                        { staticClass: "color-666 font-12 font-light" },
                        [
                          _vm._v(
                            _vm._s(_vm.detailData.aboutToExpireCount) + "人"
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]),
            ]),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                staticClass: "right-box color-bg-fff position-relative",
              },
              [
                _c("div", { staticClass: "flex flex-between" }, [
                  _vm._m(0),
                  _c("i", {
                    staticClass: "el-icon-close font-24 pointer",
                    on: { click: _vm.handleClose },
                  }),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "margin-top-20",
                    staticStyle: { height: "calc(100% - 100px)" },
                  },
                  _vm._l(_vm.list, function (item) {
                    return _c(
                      "div",
                      { key: item.driverId, staticClass: "padding-y-10 item" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex flex-align-center margin-bottom-8",
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "font-weight pointer",
                                staticStyle: { color: "#07c160" },
                                on: {
                                  click: function ($event) {
                                    return _vm.jumpDetail(item, "driver")
                                  },
                                },
                              },
                              [_vm._v(_vm._s(item.name))]
                            ),
                            _c("div", { staticClass: "margin-x-10 line" }),
                            _c(
                              "span",
                              {
                                staticClass: "font-weight pointer",
                                staticStyle: { color: "#07c160" },
                                on: {
                                  click: function ($event) {
                                    return _vm.jumpDetail(item, "car")
                                  },
                                },
                              },
                              [_vm._v(_vm._s(item.plateNumber))]
                            ),
                          ]
                        ),
                        _c(
                          "span",
                          { staticClass: "font-14 font-light color-666" },
                          [_vm._v(_vm._s(item.content))]
                        ),
                      ]
                    )
                  }),
                  0
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "text-center position-absolute color-fff btn-box color-bg-fff",
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "btn margin-top-20",
                        on: { click: _vm.seeMore },
                      },
                      [_vm._v("查看更多")]
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]),
          _c("DriverDetail", { ref: "driver" }),
          _c("VehicleDetail", { ref: "car" }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "font-14 color-666" }, [
      _vm._v("\n          请及时更新以下司机的证照信息，证照过期"),
      _c("span", { staticStyle: { color: "#fa5151" } }, [_vm._v("前3天")]),
      _vm._v("系统将自动封禁，封禁后无法使用\n        "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }